import _objectWithoutProperties from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"];
import { buildHTMLStyles } from '../../html/utils/build-styles.mjs';
import { calcSVGTransformOrigin } from './transform-origin.mjs';
import { buildSVGPath } from './path.mjs';
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */

function buildSVGAttrs(state, _ref, options, transformTemplate) {
  var attrX = _ref.attrX,
      attrY = _ref.attrY,
      originX = _ref.originX,
      originY = _ref.originY,
      pathLength = _ref.pathLength,
      _ref$pathSpacing = _ref.pathSpacing,
      pathSpacing = _ref$pathSpacing === void 0 ? 1 : _ref$pathSpacing,
      _ref$pathOffset = _ref.pathOffset,
      pathOffset = _ref$pathOffset === void 0 ? 0 : _ref$pathOffset,
      latest = _objectWithoutProperties(_ref, _excluded);

  buildHTMLStyles(state, latest, options, transformTemplate);
  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs,
      style = state.style,
      dimensions = state.dimensions;
  /**
   * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
   * and copy it into style.
   */

  if (attrs.transform) {
    if (dimensions) style.transform = attrs.transform;
    delete attrs.transform;
  } // Parse transformOrigin


  if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
  } // Treat x/y not as shortcuts but as actual attributes


  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY; // Build SVG path if one has been defined

  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

export { buildSVGAttrs };